<ng-container *ngIf="dateCreationMenu">
  <ng-container *ngIf="dateSaisieEffectif">
    <span class="saisie-effectifs-day" title="Menus validés">{{cellData.text}}</span>
  </ng-container>

  <ng-container *ngIf="dateFacturation">
    <span class="invoice-day" title="Facturation">{{cellData.text}}</span>
  </ng-container>

  <ng-container *ngIf="!dateSaisieEffectif">
    <span class="creation-menus-day" title="Menus en cours de saisie">{{cellData.text}}</span>
  </ng-container>
</ng-container>


<ng-container *ngIf="!dateCreationMenu">

  <ng-container *ngIf="dateSaisieEffectif">
    <span class="saisie-effectifs-day" title="Menus validés">{{cellData.text}}</span>
  </ng-container>

  <ng-container *ngIf="dateFacturation">
    <span class="invoice-day" title="Facturation">{{cellData.text}}</span>
  </ng-container>

  <ng-container *ngIf="!dateSaisieEffectif && !dateFacturation">
    <div title="Aucun menu">{{cellData.text}}</div>
  </ng-container>

</ng-container>
